import React from 'react';
import { AppContext } from '../../context/AppContext/context';
import { Appointment } from '../../interfaces';

function useCalendarSelectedAppointment() {
  const { state, dispatch } = React.useContext(AppContext);
  const { selectedAppointment, selectedAppointmentUpdated, openedAppointment } =
    state;

  // Set selectedAppointmentUpdated
  const setSelectedAppointmentUpdated = React.useCallback(
    (updated: boolean) => {
      dispatch({
        type: 'SET_SELECTED_APPOINTMENT_UPDATED',
        payload: updated,
      });
    },
    [dispatch],
  );

  // Set selectedAppointment to an appointment or null when none is selected
  const setSelectedAppointment = React.useCallback(
    (appointment: Appointment | null) => {
      dispatch({ type: 'SET_SELECTED_APPOINTMENT', payload: appointment });
    },
    [dispatch],
  );

  // Set openedAppointment to an appointment or null when none is selected
  const setOpenedAppointment = React.useCallback(
    (appointment: Appointment | null) => {
      dispatch({ type: 'SET_OPENED_APPOINTMENT', payload: appointment });
    },
    [dispatch],
  );

  return {
    selectedAppointment,
    selectedAppointmentUpdated,
    setSelectedAppointmentUpdated,
    setSelectedAppointment,
    openedAppointment,
    setOpenedAppointment,
  };
}

export default useCalendarSelectedAppointment;
